module.exports = __webpack_public_path__ + "static/media/V2_25.ef7c46a2.png";